import moment from 'moment';

import { getQuillPlainText } from '../../../../../components/baseV2';
import { API_DATE_FORMAT } from '../../../../../constants';

import type { ITreatmentPlanV3MedicalInfo, TreatmentPlanV3MedicalInfoPayload } from '../../../../../store/treatmentPlanV3';
import type { MedicalFormValues } from './types';

export function mapMedicalInfoToValues(info: ITreatmentPlanV3MedicalInfo | null): MedicalFormValues {
  return {
    allergies: info?.allergies ?? '',
    special_diets: info?.special_diets ?? '',
    hearing_difficulty: info?.hearing_difficulty ?? '',
    hearing_screening_date: info?.hearing_screening_date ? moment(info.hearing_screening_date, API_DATE_FORMAT, true) : null,
    vision_difficulty: info?.vision_difficulty ?? '',
    vision_screening_date: info?.vision_screening_date ? moment(info.vision_screening_date, API_DATE_FORMAT, true) : null,
    trauma_history: info?.trauma_history ?? '',
    hospitalization_history: info?.hospitalization_history ?? '',
    asd_severity_level: info?.asd_severity_level ?? '',
    asd_diagnosis_provider_name: info?.asd_diagnosis_provider_name ?? '',
    asd_diagnosis_city: info?.asd_diagnosis_city ?? '',
    asd_diagnosis_state: info?.asd_diagnosis_state ?? '',
    asd_diagnosis_year: info?.asd_diagnosis_year != null ? moment(String(info.asd_diagnosis_year), 'YYYY', true) : null,
    child_delivery_type: info?.child_delivery_type ?? '',
    child_gestational_age_weeks: info?.child_gestational_age_weeks?.toString() ?? '',
    child_weight_at_birth_pounds: info?.child_weight_at_birth_pounds?.toString() ?? '',
    child_weight_at_birth_ounces: info?.child_weight_at_birth_ounces?.toString() ?? '',
    child_sitting_up_age_months: info?.child_sitting_up_age_months?.toString() ?? '',
    child_crawling_age_months: info?.child_crawling_age_months?.toString() ?? '',
    child_walking_age_years: info?.child_walking_age_years?.toString() ?? '',
    child_walking_age_months: info?.child_walking_age_months?.toString() ?? '',
    child_standing_age_years: info?.child_standing_age_years?.toString() ?? '',
    child_standing_age_months: info?.child_standing_age_months?.toString() ?? '',
    child_babbling_age_months: info?.child_babbling_age_months?.toString() ?? '',
    child_first_word: info?.child_first_word ?? '',
    child_second_word: info?.child_second_word ?? '',
    child_first_words_age_months: info?.child_first_words_age_months?.toString() ?? '',
  };
}

export function toMedicalFieldPayload(
  name: keyof MedicalFormValues,
  values: MedicalFormValues,
): TreatmentPlanV3MedicalInfoPayload {
  switch (name) {
    case 'hearing_screening_date':
    case 'vision_screening_date':
      return { [name]: values[name]?.clone().startOf('month').format(API_DATE_FORMAT) ?? null };
    case 'asd_diagnosis_year':
      return { asd_diagnosis_year: values.asd_diagnosis_year?.year() ?? null };
    case 'child_gestational_age_weeks':
    case 'child_weight_at_birth_pounds':
    case 'child_weight_at_birth_ounces':
    case 'child_sitting_up_age_months':
    case 'child_crawling_age_months':
    case 'child_walking_age_years':
    case 'child_walking_age_months':
    case 'child_standing_age_years':
    case 'child_standing_age_months':
    case 'child_babbling_age_months':
    case 'child_first_words_age_months':
      return { [name]: values[name] === '' ? null : Number(values[name]) };
    case 'trauma_history':
    case 'hospitalization_history':
      return { [name]: getQuillPlainText(values[name]).trim() ? values[name] : null };
    default:
      return { [name]: values[name].trim() || null };
  }
}
